module.exports = __webpack_public_path__ + "img/set-yourself.84ef5081.png";